import ChapterControlsInactiveSlider from "ChapterControlsInactiveSlider/ChapterControlsInactiveSlider";
import { connect } from "react-redux";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import getDuration from "selectors/chapter/getDuration";
import getIsProgressBarProgressHidden from "selectors/chapter/getIsProgressBarProgressHidden";

const mapStateToProps = (state, ownProps) => {
  const playbackState = getPlaybackState(state, ownProps);
  return {
    duration: getDuration(state, ownProps),
    hideProgressBarProgress: getIsProgressBarProgressHidden(state, ownProps),
    time: playbackState.time,
  };
};

const connector = connect(mapStateToProps);

export default connector(ChapterControlsInactiveSlider);
